import { Button } from '@abyss/web/ui/Button';
import React from 'react';

interface SignInProps {
  url: string;
  text: string;
}

export const SignIn: React.FC<SignInProps> = ({ text, url }) => (
  <Button
    data-auto-testid="guest-header-sign-in-button"
    data-testid="guest-header-sign-in-button"
    href={url}
    openNewWindow={false}
    size="$md"
    variant="outline"
  >
    {text}
  </Button>
);
